import { useDispatch } from 'react-redux';
import { isObjectNotEmpty } from '../utils/objectUtils';
import { getCartItemOnUnofferedBundle } from '../utils/couponEligibilityUtils';
import { useDeepCompareEffectNoCheck } from './useDeepCompareEffect';
import { onChangeFrequency } from '../redux/ducks/funnel';

// the plan step offers only the single-payment plan to friends and family and under a recurring coupon that cannot
// discount a bundle, so a cart still on a bundle moves to it - whether the coupon came first or the bundle did -
// rather than billing a plan with no option selected
export const useSinglePaymentPlanOnly = ({ cartItems = [], coupon = null, isFriendsAndFamily = false } = {}) => {
	const dispatch = useDispatch();

	useDeepCompareEffectNoCheck(() => {
		const cartItemOnUnofferedBundle = getCartItemOnUnofferedBundle({ cartItems, coupon, isFriendsAndFamily });
		if (isObjectNotEmpty(cartItemOnUnofferedBundle)) {
			dispatch(onChangeFrequency(1, cartItemOnUnofferedBundle.id));
		}
	}, [cartItems, coupon, isFriendsAndFamily]);
};
